import { Box, Button, Grid, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';
import { ROUTES } from 'src/constants/routes';
import { BaseLayout } from 'src/layouts/base-layout';

interface Props {
  children: ReactNode;
}

export const References: FC<Props> = ({ children }) => {
  const { t } = useTranslation();

  return (
    <BaseLayout>
      <Box p={4}>
        <Grid container justifyContent="space-between" alignItems="center" mb={3}>
          <Grid item xs={12} md={5}>
            <Typography variant="h1">{t('references', 'Справочники')}</Typography>
            {/* <Typography variant="h1">{t('directions', 'Направления')}</Typography> */}
          </Grid>
          <Grid item mr="auto">
            <Box display="flex" justifySelf="flex-start">
              {/* <TabButton
                label={t('directions', 'Направления')}
                path={ROUTES.REFERENCES.DIRECTIONS}
              /> */}
              <TabButton
                label={t('commissions', 'Cписок комиссий')}
                path={ROUTES.REFERENCES.COMMISSIONS}
              />
              <TabButton label={t('regions', 'Регионы')} path={ROUTES.REFERENCES.REGIONS} />
              <TabButton
                label={t('specialties', 'Специальности')}
                path={ROUTES.REFERENCES.SPECIALTIES}
              />
              {/* <TabButton label={t('districts', 'Районы')} path={ROUTES.REFERENCES.DISTRICTS} /> */}
            </Box>
          </Grid>
        </Grid>

        {children}
      </Box>
    </BaseLayout>
  );
};

const TabButton: FC<{ label: string; path: string }> = ({ label, path }) => {
  const location = useLocation();
  const isActive = location.pathname === path;
  return (
    <Button
      variant={isActive ? 'contained' : 'text'}
      color="secondary"
      component={NavLink}
      to={path}
    >
      {label}
    </Button>
  );
};
